import React from 'react'
import { TextFieldSeeker } from '@ui-seeker/core'
import { AppBulkEditAction, AppDialogCancel, AppModal } from '@components'
import { useSignal } from '@preact/signals-react'
import { leadingOpenUrlModal } from 'Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals'
import { useLeadingUrlModalSubmit } from 'Pages/BusinessLogistics/LeadingAnalyzer/Page/@hooks'


export default function LeadingUrlModal() {

	const urlName = useSignal('')
	const { isLoading, setIsLoading } = useLeadingUrlModalSubmit(urlName.value)

	return <AppModal
		isOpen={!!leadingOpenUrlModal.value}
		controller={() => leadingOpenUrlModal.value = null}
		containerProps={{ maxWidth: 'sm' }}
		icon="link"
		title="Url name"
		subtitle="Custom name for the saved url"
		footer={<>
			<AppDialogCancel onClick={() => leadingOpenUrlModal.value = false}/>
			<AppBulkEditAction loading={isLoading} onClick={setIsLoading}>Confirm</AppBulkEditAction>
		</>}
	>
		<TextFieldSeeker
			label="Custom Name for the Url"
			value={urlName.value}
			onChange={e => urlName.value = e.target.value}
		/>
	</AppModal>
}